import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { divIcon } from "leaflet";
import "leaflet/dist/leaflet.css";

// Custom marker icon for property location
const createPropertyMarker = () => {
    const svgIcon = `
        <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24'>
            <circle cx='12' cy='12' r='10' fill='#E74C3C' stroke='white' stroke-width='2'/>
            <circle cx='12' cy='12' r='4' fill='white' />
        </svg>
    `;

    return divIcon({
        html: svgIcon,
        className: "custom-property-marker",
        iconSize: [30, 30],
        iconAnchor: [15, 15],
    });
};

function LeafletLocateMapLocation({ monthlyPayment, agentName, property, percentageChange, yearsSpan, onContactClick, onQualifyClick }) {
    const lat = parseFloat(property?.latitude);
    const lng = parseFloat(property?.longitude);

    const isValidLatLng = !isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng);

    if (!isValidLatLng) {
        return (
            <div className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-[400px] tw-bg-gray-100 tw-rounded-[15px]">
                <div className="tw-text-center tw-p-4">
                    <p className="tw-text-gray-600">Invalid property coordinates</p>
                </div>
            </div>
        );
    }

    return (
        <div className="tw-flex tw-items-center tw-gap-5 tw-justify-center tw-w-[100%] tw-relative tw-z-0">
            <div style={{ width: "100%", height: "400px", borderRadius: "15px", overflow: "hidden", position: "relative", zIndex: 1 }}>
                <MapContainer
                    center={[lat, lng]}
                    zoom={14}
                    style={{ height: "100%", width: "100%", position: "relative", zIndex: 1 }}
                    zoomControl={true}
                    scrollWheelZoom={true}
                    dragging={true}
                    touchZoom={true}
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker position={[lat, lng]} icon={createPropertyMarker()}>
                        <Popup>
                            <div className="tw-text-sm">
                                <strong>{property?.address || "Property Location"}</strong>
                                {property?.price && (
                                    <div className="tw-mt-1">
                                        <span className="tw-font-semibold">${property.price?.toLocaleString()}</span>
                                    </div>
                                )}
                                {property?.beds && property?.baths && (
                                    <div className="tw-mt-1 tw-text-gray-600">
                                        {property.beds} bed · {property.baths} bath
                                    </div>
                                )}
                            </div>
                        </Popup>
                    </Marker>
                </MapContainer>
            </div>
        </div>
    );
}

export default LeafletLocateMapLocation;
